import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { AnimatePresence } from 'framer-motion'
import axios from 'axios'
import './App.css'

// Pages
import HomePage from './pages/HomePage'
import GamePage from './pages/GamePage'
import ReviewPage from './pages/ReviewPage'
import ProfilePage from './pages/ProfilePage'
import FavoritesPage from './pages/FavoritesPage'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import ParentDashboard from './pages/ParentDashboard'

// Components
import Header from './components/Header'
import LevelUpModal from './components/LevelUpModal'
import ScrollToTop from './components/ScrollToTop'

function App() {
  const location = useLocation()
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [levelUpData, setLevelUpData] = useState(null)

  // Check authentication on mount
  useEffect(() => {
    checkAuth()
  }, [])

  const checkAuth = async () => {
    try {
      const response = await axios.get('/api/auth/me', { withCredentials: true })
      setUser(response.data)
    } catch (error) {
      console.log('Not authenticated')
    } finally {
      setLoading(false)
    }
  }

  const handleLogin = (userData) => {
    setUser(userData)
  }

  const handleLogout = async () => {
    try {
      await axios.post('/api/auth/logout', {}, { withCredentials: true })
      setUser(null)
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  const handleLevelUp = (newLevel, totalXP, unlockedBadges = []) => {
    setLevelUpData({ level: newLevel, xp: totalXP, unlockedBadges })
  }

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    )
  }

  return (
    <div className="App">
      <ScrollToTop />
      {user && <Header user={user} onLogout={handleLogout} />}

      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route
            path="/login"
            element={user ? <Navigate to="/" /> : <LoginPage onLogin={handleLogin} />}
          />
          <Route
            path="/register/:inviteCode"
            element={user ? <Navigate to="/" /> : <RegisterPage onRegister={handleLogin} />}
          />
          <Route
            path="/"
            element={user ? <HomePage user={user} /> : <Navigate to="/login" />}
          />
          <Route
            path="/game/:gameId"
            element={user ? <GamePage user={user} /> : <Navigate to="/login" />}
          />
          <Route
            path="/review/:gameId"
            element={user ? <ReviewPage user={user} onLevelUp={handleLevelUp} /> : <Navigate to="/login" />}
          />
          <Route
            path="/profile"
            element={user ? <ProfilePage user={user} /> : <Navigate to="/login" />}
          />
          <Route
            path="/favorites"
            element={user ? <FavoritesPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/parent"
            element={<ParentDashboard />}
          />
        </Routes>
      </AnimatePresence>

      {levelUpData && (
        <LevelUpModal
          level={levelUpData.level}
          xp={levelUpData.xp}
          unlockedBadges={levelUpData.unlockedBadges || []}
          onClose={() => setLevelUpData(null)}
        />
      )}
    </div>
  )
}

export default App
